import { STATICINFOS_SERVICE } from "@/services/staticInfos.service.js";

const state = {getStaticInfosOutput: {}, postStaticInfoOutput: false, putStaticInfoOutput: false, putStaticInfoChangeStatusOutput: false, getStaticInfoByIdOutput: {}};

const actions = {
    //Service to get static infos
    getStaticInfos({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getStaticInfosRequest');

        STATICINFOS_SERVICE.getStaticInfos(queryParams)
            .then(
                output => {
                    commit('getStaticInfosSuccess', output);
                },
                error => {
                    commit('getStaticInfosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create static infos
    postStaticInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postStaticInfoRequest');

        STATICINFOS_SERVICE.postStaticInfo(input)
            .then(
                output => {
                    commit('postStaticInfoSuccess', output);
                },
                error => {
                    commit('postStaticInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update static info
    putStaticInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putStaticInfoRequest');

        STATICINFOS_SERVICE.putStaticInfo(input)
            .then(
                output => {
                    commit('putStaticInfoSuccess', output);
                },
                error => {
                    commit('putStaticInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update status
    putStaticInfoChangeStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putStaticInfoChangeStatusRequest');

        STATICINFOS_SERVICE.putStaticInfoChangeStatus(input)
            .then(
                output => {
                    commit('putStaticInfoChangeStatusSuccess', output);
                },
                error => {
                    commit('putStaticInfoChangeStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get static info details
    getStaticInfoById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getStaticInfoByIdRequest');

        STATICINFOS_SERVICE.getStaticInfoById(id)
            .then(
                output => {
                    commit('getStaticInfoByIdSuccess', output);
                },
                error => {
                    commit('getStaticInfoByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getStaticInfos
    getStaticInfosRequest(state) {
    },
    getStaticInfosSuccess(state, output) {
        state.getStaticInfosOutput = output;
    },
    getStaticInfosFailure(state) {
        state.getStaticInfosOutput = false;
    },

    //postStaticInfo
    postStaticInfoRequest(state) {
        state.postStaticInfoOutput = null;
    },
    postStaticInfoSuccess(state, output) {
        state.postStaticInfoOutput = true;
    },
    postStaticInfoFailure(state) {
        state.postStaticInfoOutput = false;
    },

    //putStaticInfo
    putStaticInfoRequest(state) {
        state.putStaticInfoOutput = null;
    },
    putStaticInfoSuccess(state, output) {
        state.putStaticInfoOutput = true;
    },
    putStaticInfoFailure(state) {
        state.putStaticInfoOutput = false;
    },

    //putStaticInfoChangeStatus
    putStaticInfoChangeStatusRequest(state) {
        state.putStaticInfoChangeStatusOutput = null;
    },
    putStaticInfoChangeStatusSuccess(state, output) {
        state.putStaticInfoChangeStatusOutput = true;
    },
    putStaticInfoChangeStatusFailure(state) {
        state.putStaticInfoChangeStatusOutput = false;
    },

    //getStaticInfoById
    getStaticInfoByIdRequest(state) {
    },
    getStaticInfoByIdSuccess(state, output) {
        state.getStaticInfoByIdOutput = output;
    },
    getStaticInfoByIdFailure(state) {
        state.getStaticInfoByIdOutput = false;
    },
};

export const staticInfos = {
    namespaced: true,
    state,
    actions,
    mutations
};